// react
import { useState } from 'react';
import { 
    Box,
    Button,
    TextField,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// lib
import _ from 'lodash';
// service
import { 
    challenge
} from '../service/user-api';
// type
import { ChallengeRequest } from '../types/challengeRequest';

/**
 * ログイン
 * @returns 
 */
const Login = () => {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState<ChallengeRequest>({
        userId: '',
        password: '',
    });
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const handleChange = (e: any) => {
        setFormValues({
            ...formValues,
            [e.target.name]: e.target.value,
        });
    };

    /**
     * 🔴 ログインボタン押下
     * @param e 
     * @returns 
     */
    const handleSubmit = async (e: any) => {
        e.preventDefault();
        // バリデーション実施
        if (!validate()) return;
        // チャレンジリクエスト
        const data  = await challenge(formValues);
        // 失敗した場合は処理終了
        if (!data) {
            return;
        }
        // ローカルストレージに保存
        localStorage.setItem("auth", JSON.stringify(data));
        navigate('/schedule');
    };

    /**
     * バリデーション
     * @returns バリデーション結果(boolean)
     */
    const validate = (): boolean => {
        const newErrors: { [key: string]: string } = {};
        if (!formValues.userId.trim()) {
            newErrors.userId = 'ユーザーIDを入力してください';
        } else if (!/^[\x20-\x7E]+$/.test(formValues.userId)) {
            newErrors.userId = '半角英数字記号で入力してください';
        }

        if (!formValues.password.trim()) {
            newErrors.password = 'ユーザーIDを入力してください';
        } else if (!/^[\x20-\x7E]+$/.test(formValues.password)) {
            newErrors.password = '半角英数字記号で入力してください';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <Box sx={{ maxWidth: 300, mx: 'auto', mt: 5 }}>
            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    name="userId"
                    label="ユーザーID"
                    type="text"
                    value={formValues.userId}
                    onChange={handleChange}
                    margin="normal"
                    error={!!errors.userId} 
                    helperText={errors.userId} 
                />
                <TextField
                    fullWidth
                    name="password"
                    label="パスワード"
                    type="password"
                    value={formValues.password}
                    onChange={handleChange}
                    margin="normal"
                    error={!!errors.password} 
                    helperText={errors.password} 
                />
                <Button 
                    type="submit" 
                    variant="contained" 
                    color="primary" 
                    fullWidth
                    sx={{ mt: 2 }}
                >
                    ログイン
                </Button>
            </form>
        </Box>
    );
};

export default Login;